import { motion } from "framer-motion";
import React from "react";
import downarrow from "../Images/Arrows/uprightteal.png";
import offpageSEO from "../Images/serviceIcons/Off Page SEO.png";
import onpageSEO from "../Images/serviceIcons/On page SEO.png";
import technicalSEO from "../Images/serviceIcons/Technical SEO.png";

const SEOService = ({ icon, title, description, delay }) => (
  /* From Uiverse.io by Pradeepsaranbishnoi */
  <motion.div
    class="cardBox   leading-none border-teal-500 border rounded-lg shadow-xl p-6 md:p-8 flex flex-col items-center text-center h-full transform transition-transform duration-[1s] hover:shadow-2xl "
    initial={{ opacity: 0, x: -100 }} // Initial fade in from the left
    whileInView={{ opacity: 1, x: 0 }} // Fully visible when in view
    exit={{ opacity: 0, x: 100 }} // Fade out to the right when leaving view
    transition={{
      duration: 1.2, // Slow down for smoother animation
      ease: "easeInOut", // Use easing for smooth transitions
      delay: delay, // Stagger effect for each card
    }}
    viewport={{ once: false, amount: 0.2 }} // Replay animation when back in view
  >
    <div class="card bg-gradient-to-br from-blue-500 via-teal-500 to-teal-400">
      <div className="mb-6 w-20 h-20 flex items-center justify-center bg-white border-4 border-white shadow-lg rounded-full">
        <img src={icon} alt="Service Icon" className="w-12 h-12" />
      </div>
      <h4 className="text-lg font-bold text-teal-900 mb-4">{title}</h4>
      <ul className="text-white text-sm space-y-2">
        {description.map((item, index) => (
          <li key={index} className="leading-tight">
            {item}
          </li>
        ))}
      </ul>
    </div>
  </motion.div>
);

const SEOServices = () => {
  const services = [
    {
      icon: technicalSEO,
      title: "Technical SEO",
      description: [
        "Comprehensive Technical SEO",
        "Google Analytics & Search Console Setup",
        "eCommerce SEO",
        "Monthly Performance Report",
        "Site Speed Optimization",
      ],
    },
    {
      icon: onpageSEO,
      title: "On-Page SEO",
      description: [
        "Website Audit",
        "Keyword Research & Strategy",
        "On-Page Optimization",
        "Content Creation & Strategy",
        "Internal Linking Optimization",
      ],
    },
    {
      icon: offpageSEO,
      title: "Off-Page SEO",
      description: [
        "Link Building & Outreach",
        "Guest Blogging",
        "Profile Backlinks",
        "Local SEO",
        "Social Media Integration",
      ],
    },
  ];

  return (
    <div className="w-full  px-4 py-12 relative mx-auto ">
      {/* Top-left arrow image */}
      <img
        src={downarrow}
        alt="Top Left Arrow"
        className="absolute top-5 left-10 md:left-10 lg:left-40 w-36 h-40 hidden lg:flex"
        style={{ transform: "rotate(70deg)" }}
      />

      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-4 text-teal-600 md:mt-20">
        Our SEO Services
      </h1>
      <p className="text-xl text-center text-gray-500 mb-12">
        Increase Your Search Rankings and Get Discovered More Online
      </p>
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 ">
        {services.map((service, index) => (
          <SEOService key={index} {...service} delay={index * 0.2} />
        ))}
      </div>
    </div>
  );
};

export default SEOServices;
